import api from '@/apis/bu/bUCommitmentAdjustmentAPI.js';
import Crud from '@/stores/crudBase';
import voucherAPI from '@/apis/lg/voucherAPI.js';
var crud = new Crud('bUCommitmentAdjustment', api);

const state = {
  ...crud.state,
  _config: {
    table: 'bu_commitment_adjustment',
    field: {
      key: 'ref_id',
      code: 'ref_no',
      posted: 'is_posted',
    },
  },
};
const getters = {
  ...crud.getters,
};

//NVTUAN1 11.01.2024: Chuyển hàm changeStatusPosted và changeStatusPostedBatchs từ bên crudBase sang vì 2 hàm này chỉ đáp ứng cho màn Cam kết chi
const actions = {
  ...crud.actions,

  /**
   * Thay đổi trạng thái trường is_posted (ghi sổ)
   * HQMINH 20.07.2022
   */
  async changeStatusPosted(context, payload) {
    let res = await voucherAPI.changeStatusPosted(payload);
    if (res.is_success == true) {
      let param = { data: [payload.data], value: payload.data.is_posted };
      //cập nhật danh sách
      context.commit('updateChangeStatusPosted', param);
    }
    return res;
  },

  /**
   * Thay đổi trạng thái trường is_posted (ghi sổ)
   * HQMINH 20.07.2022
   */
  async changeStatusPostedBatchs(context, payload) {
    let res = await voucherAPI.changeStatusPostedBatchs(payload);
    if (res.is_success == true || res.length === 0) {
      let param = { data: [payload.data], value: payload.data.is_posted };

      //cập nhật danh sách
      context.commit('updateChangeMutilItemPosted', param);
    }
    return res;
  },
};

//NVTUAN1 11.01.2024: Chuyển hàm updateChangeStatusPosted và updateChangeMutilItemPosted từ bên crudBase sang vì 2 hàm này chỉ đáp ứng cho màn Cam kết chi
const mutations = {
  ...crud.mutations,

  /**
   * Cập nhật khi sửa bản ghi ghi sổ cho cam kết chi
   * HQMINH 20.07.2022
   */
  updateChangeStatusPosted(state, payload) {
    let postedField = state._config.field.posted,
      keyField = state._config.field.key,
      data = payload.data,
      value = payload.value;
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        if (keyField && postedField) {
          let id = data[i];
          let objValue = {};
          objValue[postedField] = value;

          for (let j = 0; j < state.items.length; j++) {
            let item = state.items[j];

            if (item[keyField] === id?.refId) {
              Object.assign(item, objValue);
              // break;
            }
          }
        }
      }
    }

    state.version++;
  },

  /**
   * Cập nhật khi sửa bản ghi ghi sổ cho cam kết chi
   * HQMINH 20.07.2022
   */
  updateChangeMutilItemPosted(state, payload) {
    let postedField = state._config.field.posted,
      keyField = state._config.field.key,
      data = payload.data[0];
    if (data && data.length) {
      for (let i = 0; i < data.length; i++) {
        if (keyField && postedField) {
          let id = data[i];
          let value = data[i].is_posted;
          let objValue = {};
          objValue[postedField] = value;

          for (let j = 0; j < state.items.length; j++) {
            let item = state.items[j];

            if (item[keyField] === id?.refId) {
              Object.assign(item, objValue);
              // break;
            }
          }
        }
      }
    }

    state.version++;
  },
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
